// extracted by mini-css-extract-plugin
export default {"cancelSearchBtn":"cancelSearchBtn--af4e532643070bd5bfa6"};